import(/* webpackMode: "eager" */ "/app/node_modules/next/font/local/target.css?{\"path\":\"src/fonts/geologica.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"./Geologica.woff2\",\"weight\":\"100 900\",\"display\":\"swap\",\"variable\":\"--font-zeit\"}],\"variableName\":\"geologica\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/app/src/app/operator/theme.tsx");
